import { useSelector } from "react-redux";
import { Helmet } from "react-helmet-async";
import { useEffect, useState } from "react";
import { RootState, useAppDispatch } from "../../../redux/store";
import { retrievePageMenu } from "../../../redux/slice/page-menu.slice";
import TwoColumnLayOut from "../../../layouts/two-columns/two-column-layout";
import LoadingComp from "../../../components/re-usable/loading/loading";

const RAPSFellowsMain = () => {
  const path = "Membership%2FRAPS-Fellows";

  const dispatch = useAppDispatch();
  const { RapsEuropeData } = useSelector((state: RootState) => state.rapsEurope);

  useEffect(() => {
    dispatch(retrievePageMenu(`%2F${path}`));
  }, [dispatch]);

  // Page published check
  const [isPublished, setIsPublished] = useState(false);

  useEffect(() => {
    if (RapsEuropeData[0]?.result !== undefined) {
      setIsPublished(true);
    }
  }, [RapsEuropeData]);

  if (!isPublished) return <LoadingComp />;
  // End Page published check

  return (
    <>
      <Helmet>
        <title>{RapsEuropeData[0]?.result[0].menuItemName}</title>
      </Helmet>

      <TwoColumnLayOut breadcrumbPath={path} isBreadcrumbpath={true} showAds={true}>
        <div dangerouslySetInnerHTML={{ __html: RapsEuropeData[0]?.result[0]?.description }}></div>
      </TwoColumnLayOut>
    </>
  );
};

export default RAPSFellowsMain